import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export default function formatUtcDateTime(
  dateTime: string,
  formatStr: string = "dd MMM yyyy, h:mm a"
) {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const localDate = toZonedTime(new Date(dateTime), userTimeZone);

  return format(localDate, formatStr);
}

export function timeStringToDate(time: string | undefined) {
  if (!time) return null;
  const [h, m] = normalizeTime(time).split(":").map(Number);
  const d = new Date();
  d.setHours(h, m, 0, 0);
  return d;
}

export function normalizeTime(time: string) {
  // Handles "HH:mm" and "HH:mm:ss"
  const [h, m] = time.split(":");
  return `${h}:${m}`;
}

export function formatDateTimeRange(
  date: string | undefined,
  start: string | undefined,
  end: string | undefined
) {
  if (!date || !start || !end) return "";

  const s = new Date(`${date}T${normalizeTime(start)}:00`);
  const e = new Date(`${date}T${normalizeTime(end)}:00`);

  return `${format(s, "dd MMM yyyy, h:mm a")} – ${format(e, "h:mm a")}`;
}
